import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportHeaderComponent } from './report-header.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [ReportHeaderComponent],
  entryComponents: [ReportHeaderComponent],
  exports: [ReportHeaderComponent],
})
export class ReportHeaderModule {}



// WEBPACK FOOTER //
// ./src/app/components/report-header/report-header.module.ts